import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchTutorsApi } from '~/features/tutor/api/tutor.api';

import type { Tutor } from '~/features/tutor/types/tutor.type';

export interface TutorState {
  tutors: Tutor[];
  isLoading: boolean;
  /**
   * 조회를 한 번이라도 끝냈는지.
   * @description `tutors.length === 0` 만으로는 "아직 안 불러옴"과 "지도사가 없음"이 구분되지 않아
   *  로딩 중에 "지도사가 없습니다"가 깜빡인다. 판정 근거를 따로 둔다(profile.slice 와 같은 이유).
   */
  isLoaded: boolean;
  /** 동시 요청 경합 방지 — 늦게 끝난 옛 요청이 최신 결과를 덮어쓰지 못하게 한다. */
  currentRequestId?: string;
}

const initialState: TutorState = {
  tutors: [],
  isLoading: false,
  isLoaded: false,
};

export const fetchTutors = createAsyncThunk<Tutor[], void>(
  'tutor/fetchTutors',
  async (_, { rejectWithValue }) => {
    try {
      return await fetchTutorsApi();
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

const TutorSlice = createSlice({
  initialState,
  name: 'tutor',
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTutors.pending, (state, action) => {
        state.isLoading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchTutors.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.tutors = action.payload;
        state.isLoading = false;
        state.isLoaded = true;
      })
      .addCase(fetchTutors.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) return;
        state.isLoading = false;
        // 실패도 "확인은 끝난" 상태로 둔다 — 무한 로딩보다 빈 목록이 낫다.
        state.isLoaded = true;
      });
  },
});

export default TutorSlice;
